import { GoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import { googleLogInDataStorage } from '../services/account';
import { data } from 'react-router-dom';
import baseUrl from '../config/baseURL';

const GoogleLoginButton = () => {
  const handleSuccess = async (credentialResponse: any) => {
    try {
      const { credential } = credentialResponse;
      const response = await axios.post(`${baseUrl}/core/auth/google/`, {
        token: credential,
      });

      console.log('google auth response', response);

      // Store JWT/session
      const { access, refresh } = response.data;
      let responseFromStorage = await googleLogInDataStorage(access, refresh);
      alert('Logged in successfully!');
      window.location.href = "/home";
      
    } catch (error) {
      console.error('Login failed', error);
    }
  };

  return <GoogleLogin text='signin_with' onSuccess={handleSuccess} onError={() => console.log('Login Failed')} />;
};

export default GoogleLoginButton;
